import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import TocStockHeader from "../../CommonTocComponent/TocHeader/TocStockHeader";
import SingleHeadingText from "../../CommonTocComponent/TocHeader/SingleHeadingText";
import { subtitleDiffMandate } from "../MutualFundConstant";
import { Col, Row } from "react-bootstrap";
import SignOnMandate from "./SignOnMandate";
import CreateNewMandateData from "./CreateNewMandateData";
import { EMutualFundFlow } from "../MutualFund";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import NewMandate from "./NewMandate";
import { base64toPDF } from "@frameworks/web/utils/base64_functions";
import EmandateInfoPage from "./EmandateInfoPage";
import { useNavigate } from "react-router-dom";
import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
export var EMandateType;
(function (EMandateType) {
    EMandateType["PHYSICAL"] = "X";
    EMandateType["EMANDATE"] = "E";
})(EMandateType || (EMandateType = {}));
export var EMandateFlow;
(function (EMandateFlow) {
    EMandateFlow["CREATE"] = "CREATE";
    EMandateFlow["UPLOAD"] = "UPLOAD";
    EMandateFlow["SHOW"] = "SHOW";
    EMandateFlow["INFOPAGE"] = "INFOPAGE";
})(EMandateFlow || (EMandateFlow = {}));
const CreateNewMandate = (props) => {
    const device = DeviceContext();
    const navigate = useNavigate();
    let window2 = null;
    const isImpersonated = window.localStorage.getItem('isImpersonated');
    const cipDetails = JSON.parse(window.sessionStorage.getItem('cipDetails'));
    const [mandateFlow, setMandateFlow] = useState(EMandateFlow.CREATE);
    const [mandateType, setMandateType] = useState(EMandateType.PHYSICAL);
    const [newMandate, setNewMandate] = useState(props.selectedMandate);
    const [amount, setAmount] = useState();
    const [disableSubmit, setDisableSubmit] = useState(true);
    useEffect(() => {
        if (amount && Number(amount) >= 50000) {
            setDisableSubmit(false);
        }
        else {
            setDisableSubmit(true);
        }
    }, [amount]);
    const getMandateUrl = (mandateID) => {
        tocDi.mandate.getEmandateUrl({ mandateId: mandateID })
            .then((data) => {
            if (data && data.message)
                window2.location.href = data.message;
        }).catch((error) => console.log(error));
    };
    const onSubmit = () => {
        var _a, _b, _c, _d;
        setDisableSubmit(true);
        if (isImpersonated)
            var rmDetails = (cipDetails.dealerid != "" ? cipDetails.dealerid : cipDetails.empcodetxt);
        const payload = {
            mndAmt: amount,
            bnkNm: (_a = props.selectedBank) === null || _a === void 0 ? void 0 : _a.bnkNm,
            brn: (_b = props.selectedBank) === null || _b === void 0 ? void 0 : _b.brn,
            bnkAcNo: (_c = props.selectedBank) === null || _c === void 0 ? void 0 : _c.bnkAcNo,
            ifsc: (_d = props.selectedBank) === null || _d === void 0 ? void 0 : _d.ifscCode,
            mandateType: mandateType,
            requestedBy: isImpersonated ? "RM_" + rmDetails : ""
        };
        if (mandateType === EMandateType.EMANDATE && !isImpersonated)
            window2 = window.open(config.rootUrl + "mutualFund/redirecting", "_blank");
        tocDi.mandate
            .createMandate(payload)
            .then((data) => {
            if (data.mandateId) {
                tocDi.mandate.getMfMandate().then((mfMandate) => {
                    var _a;
                    if (mfMandate.lst.length > 0) {
                        setNewMandate((_a = mfMandate.lst) === null || _a === void 0 ? void 0 : _a.find((x) => x.mandateId === data.mandateId));
                        if (mandateType === EMandateType.PHYSICAL || isImpersonated)
                            setMandateFlow(EMandateFlow.UPLOAD);
                        else {
                            if (mandateType === EMandateType.EMANDATE)
                                setMandateFlow(EMandateFlow.INFOPAGE);
                            setTimeout(() => {
                                getMandateUrl(data.mandateId);
                            }, 60000);
                        }
                    }
                });
            }
        })
            .catch((error) => console.log(error))
            .finally(() => setDisableSubmit(false));
        //setMandateFlow(EMandateFlow.UPLOAD);
    };
    const uploadImageSubmit = (imageData) => {
        const payload = {
            img: imageData === null || imageData === void 0 ? void 0 : imageData.base64Data.split(",")[1],
            imgnm: imageData === null || imageData === void 0 ? void 0 : imageData.docFile,
            mndtid: newMandate === null || newMandate === void 0 ? void 0 : newMandate.mandateId,
        };
        tocDi.mandate
            .uploadMandateImg(payload)
            .then((data) => {
            if (data) {
                setMandateFlow(EMandateFlow.SHOW);
            }
        })
            .catch((error) => console.log(error));
        setMandateFlow(EMandateFlow.SHOW);
    };
    const downloadData = () => {
        tocDi.mandate
            .downloadMandate({
            mandateId: newMandate === null || newMandate === void 0 ? void 0 : newMandate.mandateId,
            clientId: newMandate === null || newMandate === void 0 ? void 0 : newMandate.clientCode,
        })
            .then((data) => {
            if (data.data.length > 0) {
                base64toPDF(data.data);
            }
        });
    };
    const MandateFlowRender = () => {
        switch (mandateFlow) {
            case EMandateFlow.CREATE:
                return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                    React.createElement(TocStockHeader, { children: React.createElement("div", { className: "toc-heading d-flex align-items-center justify-content-between" },
                            React.createElement("label", { className: "DMSans_16_500 txt_blackOne1  d-flex" }, "New Mandate Creation")) }),
                    React.createElement("div", { className: "outer-body-section mainScroll scroll-height customScrollUi" },
                        React.createElement(CreateNewMandateData, { setShow: props.setShow, selectedBank: props.selectedBank, setAmount: setAmount, amount: amount, mandateType: mandateType, setMandateType: setMandateType })),
                    React.createElement("div", { className: "bottom-contents" },
                        React.createElement(Row, { className: "bottombtnsection mb-2 pb-2 pt-3 bg-white mx-0" },
                            React.createElement(Col, { lg: 6, xs: 6 },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100", onClick: () => props.setShow(EMutualFundFlow.PURCHASE) })),
                            React.createElement(Col, { lg: 6, xs: 6 },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Authorize Mandate", disabled: disableSubmit, className: "w-100", onClick: () => onSubmit() })))))) : (React.createElement(React.Fragment, null,
                    React.createElement(GenericDrawer, { show: props.show, setShow: props.setShow, headerComp: React.createElement(React.Fragment, null,
                            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Create New Mandate")), bodyComp: React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "outer-body-section overflow-scroll-300 " },
                                React.createElement(CreateNewMandateData, { setShow: props.setShow, selectedBank: props.selectedBank, setAmount: setAmount, amount: amount, mandateType: mandateType, setMandateType: setMandateType })),
                            React.createElement(Row, { className: "bottombtnsection mb-2 pb-2 pt-3 bg-white mx-0" },
                                React.createElement(Col, { lg: 6, xs: 6 },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Back", className: "w-100", onClick: () => {
                                            props.setShow(EMutualFundFlow.PURCHASE);
                                        } })),
                                React.createElement(Col, { lg: 6, xs: 6 },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Authorize Mandate", className: "w-100", onClick: onSubmit })))) })))));
            case EMandateFlow.UPLOAD:
                return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                    React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Validate your mandate", subTitle: subtitleDiffMandate, showAdditionalDetails: false, parentclassName: "diffmandate-head", closeFunction: () => {
                                props.setShow(false);
                            } }) }),
                    React.createElement(SignOnMandate, { onSubmit: (data) => uploadImageSubmit(data), onDownload: () => downloadData() }))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "bg-white" },
                        React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Sign on your mandate"),
                        React.createElement(SignOnMandate, { onSubmit: (data) => uploadImageSubmit(data), onDownload: () => downloadData() }))))));
            case EMandateFlow.SHOW:
                return (React.createElement(NewMandate, { show: true, setShow: props.setShow, selectedMandate: newMandate, onClose: () => props.setSelectedMandate(newMandate) }));
            case EMandateFlow.INFOPAGE:
                return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
                    React.createElement(TocStockHeader, { children: React.createElement("div", { className: "toc-heading d-flex align-items-center justify-content-between" },
                            React.createElement("label", { className: "DMSans_16_500 txt_blackOne1  d-flex" }, "Mandate Creation in Process")) }),
                    React.createElement(EmandateInfoPage, { setShow: props.setShow }))) : (React.createElement(React.Fragment, null,
                    React.createElement(GenericDrawer, { show: props.show, setShow: props.setShow, headerComp: React.createElement(React.Fragment, null,
                            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Mandate Creation in Process")), bodyComp: React.createElement(EmandateInfoPage, { setShow: props.setShow }) })))));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MandateFlowRender, null)));
};
export default CreateNewMandate;
